/** Banner konumu: Popup (`ILocationEnum.Modal`). */
export const BANNER_LOCATION_POPUP = 8

/**
 * "Gini Tanıtım" işareti yalnız Popup konumunda seçilebilir.
 * Banner tipinden bağımsızdır: video (YouTube, Vimeo, mp4), görsel veya GIF olabilir.
 */
export function isGiniIntroAllowed(location?: number | string | null): boolean {
  return Number(location) === BANNER_LOCATION_POPUP
}

/** Gönderilecek `IsGiniIntro`: konum Popup değilse daima false. */
export function resolveIsGiniIntro(location: number | string | null | undefined, value?: boolean): boolean {
  return isGiniIntroAllowed(location) && !!value
}
